import { render, staticRenderFns } from "./softphone.vue?vue&type=template&id=f2d0fa10&"
import script from "./softphone.vue?vue&type=script&lang=js&"
export * from "./softphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports